<template>
    <div class="input-group">
        <span
            v-if="showIcon === undefined || showIcon"
            class="input-group-text"
            :class="body ? 'bg-danger text-white' : ''"
        >
            <svg :width="iconSize" :height="iconSize" fill="currentColor">
                <use :xlink:href="'/assets/icons/bootstrap-icons.svg#' + icon" />
            </svg>
        </span>
        <input
            :type="inputType"
            class="form-control"
            :class="'is-' + (body ? 'invalid' : 'valid')"
            :placeholder="placeholder"
            autocomplete="off"
            @input="$emit('update:modelValue', $event.target.value)"
            @keyup="$emit('validate')"
            @blur="$emit('validate')"
            @change="$emit('onChange', $event)"
            v-model="inputTextField"
        />
        <div
            :class="(body ? 'invalid' : 'valid') + '-feedback'"
            v-if="(showErrorInfo === undefined || showErrorInfo) && body"
            v-html="body"
        ></div>
    </div>
</template>


<script>
    import { ref, watchEffect } from 'vue';

    export default {
        name: 'ValidateInput2',
        props: {
            modelValue: null,
            showIcon: {
                type: Boolean,
                default: true,
            },
            icon: {
                type: String,
                default: "info",
            },
            iconSize: {
                type: Number,
                default: 20,
            },
            inputType: {
                type: String,
                default: "text",
            },
            showErrorInfo: {
                type: Boolean,
                default: true,
            },
            body: {
                type: String,
                default: "",
            },
            placeholder: {
                type: String,
                default: "",
            },
        },
        setup(props) {
            const inputTextField = ref('');

            watchEffect(() => {
                inputTextField.value = props.modelValue;
            });

            return {
                inputTextField,
            };
        },
    };
</script>


<style lang="scss" scoped>
.is-valid{
    background-size: calc(.55em + .175rem) calc(.55em + .175rem);
}
.form-control::placeholder{
    font-size: 9pt;
}
</style>
